/** The example ticket the editor previews a discount on. */
import { applyCampaignToUnitPrice, type CampaignDiscount } from '@bonsai/shared';

export const SAMPLE_WORKSHOP = { title: 'Intro to Bonsai', priceCents: 6800 } as const;

/** The sample ticket's price under the discount. */
export function samplePriceAfter(discount: CampaignDiscount): number {
  return applyCampaignToUnitPrice(SAMPLE_WORKSHOP.priceCents, discount).discountedUnitPriceCents;
}
